<template>
  <div class="container">
    <el-breadcrumb separator=">" class="title">
      <el-breadcrumb-item :to="{ path: '/coach_list' }">教练管理</el-breadcrumb-item>
      <el-breadcrumb-item>批量添加教练</el-breadcrumb-item>
    </el-breadcrumb>
    <el-table
      v-show="errCoachList.length"
      class="table"
      :data="errCoachList"
      :max-height="tableHeight"
      style="width: 100%">
      <el-table-column
        fixed="left"
        prop="seqNo"
        label="行号"
        align="center"
        width="80">
      </el-table-column>
      <el-table-column
        prop="errorMsg"
        label="错误信息"
        align="center"
        width="250">
      </el-table-column>
      <el-table-column
        prop="no"
        label="证件号/No"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        prop="name"
        label="姓名"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        prop="nameEnglish"
        label="英文名字"
        align="center"
        width="150">
      </el-table-column>
      <el-table-column
        prop="phoneNo"
        label="手机号"
        align="center"
        width="120">
      </el-table-column>
      <el-table-column
        prop="disclosureDue"
        label="无犯罪证明到期时间"
        align="center"
        width="120">
      </el-table-column>
      <el-table-column
        prop="firstAidDue"
        label="急救到期时间"
        align="center"
        width="120">
      </el-table-column>
      <el-table-column
        prop="memberFeeDue"
        label="会费到期时间"
        align="center"
        width="120">
      </el-table-column>
      <el-table-column
        prop="qualifications1"
        label="教练等级"
        align="center"
        width="150">
      </el-table-column>
      <el-table-column
        prop="cpdDue1"
        label="cpd到期时间"
        align="center"
        width="120">
      </el-table-column>
      <el-table-column
        prop="qualifications2"
        label="教练等级2"
        align="center"
        width="150">
      </el-table-column>
      <el-table-column
        prop="cpdDue2"
        label="cpd到期时间2"
        align="center"
        width="120">
      </el-table-column>
      <el-table-column
        prop="qualifications3"
        label="教练等级3"
        align="center"
        width="150">
      </el-table-column>
      <el-table-column
        prop="cpdDue3"
        label="cpd到期时间3"
        align="center"
        width="120">
      </el-table-column>
      <el-table-column
        prop="isBlack"
        label="黑名单"
        align="center">
      </el-table-column>
    </el-table>
    <el-table
      v-show="coachList.length"
      class="table"
      :data="coachList"
      :max-height="tableHeight"
      style="width: 100%">
      <el-table-column
        fixed="left"
        prop="seqNo"
        label="行号"
        align="center"
        width="80">
      </el-table-column>
      <el-table-column
        prop="no"
        label="证件号/No"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        prop="name"
        label="姓名"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        prop="nameEnglish"
        label="英文名字"
        align="center"
        width="150">
      </el-table-column>
      <el-table-column
        prop="phoneNo"
        label="手机号"
        align="center"
        width="120">
      </el-table-column>
      <el-table-column
        prop="disclosureDue"
        label="无犯罪证明到期时间"
        align="center"
        width="120">
      </el-table-column>
      <el-table-column
        prop="firstAidDue"
        label="急救到期时间"
        align="center"
        width="120">
      </el-table-column>
      <el-table-column
        prop="memberFeeDue"
        label="会费到期时间"
        align="center"
        width="120">
      </el-table-column>
      <el-table-column
        prop="qualifications1"
        label="教练等级"
        align="center"
        width="150">
      </el-table-column>
      <el-table-column
        prop="cpdDue1"
        label="cpd到期时间"
        align="center"
        width="120">
      </el-table-column>
      <el-table-column
        prop="qualifications2"
        label="教练等级2"
        align="center"
        width="150">
      </el-table-column>
      <el-table-column
        prop="cpdDue2"
        label="cpd到期时间2"
        align="center"
        width="120">
      </el-table-column>
      <el-table-column
        prop="qualifications3"
        label="教练等级3"
        align="center"
        width="150">
      </el-table-column>
      <el-table-column
        prop="cpdDue3"
        label="cpd到期时间3"
        align="center"
        width="120">
      </el-table-column>
      <el-table-column
        prop="isBlack"
        label="黑名单"
        align="center">
      </el-table-column>
    </el-table>
    <div slot="tip" class="upload-tip">请按照模板格式编写excel文件，文件大小不可超过3M</div>
    <el-row style="margin-top: 20px">
      <el-col :span="5">
        <el-upload
          ref="uploadRef"
          class="upload-demo"
          name="excelFile"
          :multiple="false"
          :data="{userId: user.userId}"
          action="/basiCP/instructor/addBatchVerify/"
          :limit="1"
          :on-success="handleExcelSuccess"
          :before-upload="beforeAvatarUpload"
          :on-exceed="handleExceed">
          <el-button size="small" type="primary">{{btnText}}</el-button>
        </el-upload>
      </el-col>
      <el-col :span="18">
        <el-button
          size="small"
          type="primary"
          @click="onSubmit(2)"
          :disabled="saveDisable"
          :loading="loading">
          保存
        </el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script type="text/ecmascript-6">
  import { mapGetters } from 'vuex';
  import { addCoaches } from '@/api/coach';

  export default {
    data() {
      return {
        errCoachList: [],
        coachList: [],
        loading: false,
        batchNo: '',
        uploadDisable: false,
        saveDisable: true,
        btnText: '请上传文件',
        tableHeight: 500
      };
    },
    mounted() {
      let orderHeight = document.body.clientHeight;
      this.tableHeight = orderHeight - 284;
    },
    methods: {
      handleExceed(files) {
        this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件`);
      },
      handleExcelSuccess(res) {
        this.$refs.uploadRef.clearFiles();
        this.btnText = '重新上传';
        if (res.rspCode === 0) {
          this.saveDisable = false;
          this.coachList = res.instructors;
          this.errCoachList = [];
          this.batchNo = res.batchNo;
        } else {
          this.errCoachList = res.instructors;
          this.coachList = [];
          this.batchNo = '';
        }
      },
      beforeAvatarUpload(file) {
        const isExcel = (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/vnd.ms-excel');
        const isLt3M = file.size / 1024 / 1024 < 3;
        if (!isExcel) {
          this.$message.error('上传文件只能是 excel 格式!');
        }
        if (!isLt3M) {
          this.$message.error('上传文件大小不能超过 3MB!');
        }
        return isExcel && isLt3M;
      },
      onSubmit(type) {
        const { userId } = this.user;
        if (this.batchNo) {
          addCoaches(userId, this.batchNo).then((res) => {
            if (res.rspCode === 0) {
              this.$message.success('批量导入成功');
            } else {
              this.$message.error('批量导入失败');
            }
          }).catch((e) => {
            this.$message.error('批量导入失败');
          });
        }
      }
    },
    computed: {
      ...mapGetters([
        'user'
      ])
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus" rel="stylesheet/stylus">
  .container
    .title
      margin-bottom: 20px;
    .upload-tip
      margin-top: 20px;
</style>